"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { d: "M15.8417 22v-7.7545h2.6536l.3972-3.0221h-3.0508V9.294c0-.875.2477-1.4713 1.5268-1.4713L19 7.822V5.119C18.7178 5.0824 17.7494 5 16.6227 5c-2.3522 0-3.9624 1.4083-3.9624 3.9948v2.2286H10v3.0221h2.6603V22H3c-.5523 0-1-.4477-1-1V3c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1h-5.1583Z" })), 'FacebookIcon');
